var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-navigation'),_c('el-divider'),(_vm.$canAndRulesPass(_vm.user, 'main_page.see_graph_plan') || _vm.$canAndRulesPass(_vm.user, 'main_page.see_graph_assessment'))?_c('home-charts'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }